import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { notify } from '@offerzen/react-utils'
import { Card, LazyImage, Heading } from '@offerzen/pinata'
import SceneLayout from '../../components/SceneLayout'

import styles from './styles'

const CandidateExperienceError = ({ user, error }) => {
  useEffect(() => {
    const safeErrorMessage = error?.message && error.message.trim().split(/\n/g)[0]
    notify('😾 - user is viewing the grumpy cat', user, { errorMessage: safeErrorMessage })
  }, [user, error])

  return (
    <SceneLayout>
      <Card className={styles.card}>
        <LazyImage loader={() => import('../../../assets/grumpy-cat-sitting.svg')} alt="" width={280} />
        <Heading>Something went wrong. How awful.</Heading>
      </Card>
    </SceneLayout>
  )
}

export default CandidateExperienceError

CandidateExperienceError.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    role: PropTypes.string,
  }),
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
}
